import { HStack, Text, View } from "native-base";
import React, { ReactElement } from "react";
import { StyleSheet, TouchableHighlight } from "react-native";
import Theme from "../argon-ui/Theme";
import { translate } from "../locales/translate";

type Props = {
  tabs: string[];
  tab: string;
  handleChange: (tab: string) => void;
  children: ReactElement;
  containerStyle?: any;
};

const TabBase = ({
  tabs,
  tab,
  handleChange,
  children,
  containerStyle,
}: Props) => {
  return (
    <>
      <HStack space="2" style={[containerStyle, styles.tabs]}>
        {/* === Header === */}
        {tabs.map((tabItem: string, i: number) => {
          return (
            <TouchableHighlight
              key={i}
              underlayColor="transparent"
              onPress={() => handleChange(tabItem)}
              style={tab === tabItem ? styles.tabActive : styles.tab}
            >
              <Text
                style={[
                  styles.tabTextStyle,
                  tab === tabItem ? styles.tabTextActive : styles.tabText,
                ]}
              >
                {translate(`tabs.${tabItem}`)}
              </Text>
            </TouchableHighlight>
          );
        })}
        {/* === Body === */}
      </HStack>
      {children && <View style={styles.tabContent}>{children}</View>}
    </>
  );
};

const tabStyle: any = {
  height: 40,
  borderWidth: 1,
  borderColor: "transparent",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
};
const styles = StyleSheet.create({
  tabs: {
    direction:"ltr",
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
    marginBottom: 5,
    padding: 5,
    borderRadius: 5,
  },
  tabTextStyle: {
    fontSize: 12,
  },
  tab: {
    ...tabStyle,
  },
  tabActive: {
    ...tabStyle,
    backgroundColor: "#fdfdfd",
    borderRadius: 5,
    borderColor: "#e9e9e9",
  },
  tabText: {
    color: "#777",
  },
  tabTextActive: {
    color: "#000",
    fontWeight: "bold",
  },
  tabContent: {
    marginBottom: 15,
    padding: 5,
  },
});

export default TabBase;
